import React, { useEffect, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { Switch } from "antd";
import { MdOutlineArrowBack } from "react-icons/md";

import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import { API_CREATE_ROLE } from "api/role-management";
import { API_CREATE_CATAGORY } from "api/catagory-managemnt";
import { API_UPDATE_CATAGORY } from "api/catagory-managemnt";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API_GET_CATAGORY } from "api/catagory-managemnt";

const EditCatagory = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const location = useLocation();
  const Navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  let { id } = useParams();

  const fetchData = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_CATAGORY(id);
      console.log("provider", newData);
      setData(newData?.category);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);
  // const data = location.state && location.state.data;
  console.log("EditCatagory", data);

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            enableReinitialize
            initialValues={{
              title: data?.title,
              description: data?.description,
            }}
            validationSchema={Yup.object({
              title: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   const userData = await API_UPDATE_CATAGORY(values, data?._id);
              //   toast.success(userData?.message);
              //   Navigate("/admin/catagory/catagory-tables");
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div>
                  <div
                    className="mb-8 flex cursor-pointer items-center gap-2"
                    onClick={() => {
                      Navigate(-1);
                    }}
                  >
                    <MdOutlineArrowBack
                      className="cursor-pointer"
                      style={{ fontSize: "17px" }}
                    />
                    <p>{t("Back")}</p>
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Catagory Name")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="title"
                          placeholder={t("Catagory Name")}
                          maxlength={20}
                          onKeyPress={(event) => {
                            const charCode = event.charCode;
                            if (
                              !(charCode >= 65 && charCode <= 90) && // A-Z
                              !(charCode >= 97 && charCode <= 122) && // a-z
                              charCode !== 32 // space
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Catagory Description")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          as="textarea"
                          name="description"
                          placeholder={t("Catagory Description")}
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Updating..." : " Update Catagory"} */}
                    {isSubmitting
                      ? t("Updating") + "..."
                      : t("Update Catagory")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const userData = await API_UPDATE_CATAGORY(
                  valuesData,
                  data?._id
                );
                toast.success(userData?.message);
                Navigate("/admin/catagory/catagory-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">{t("Save Changes")}</p>
                <p className="mb-8 font-medium">
                  {t("Do you want to Save Changes before leaving the Page?")}
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const userData = await API_UPDATE_CATAGORY(
                        valuesData,
                        data?._id
                      );
                      toast.success(userData?.message);
                      Navigate("/admin/catagory/catagory-tables");
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  {t("Save Changes")}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditCatagory;
